import { z } from "zod";

// Zod schema for Auto-Renew content from CMS
export const autoRenewContentSchema = z.object({
  title: z.string().min(1, { message: "Title is required" }),
  body: z.string().min(1, { message: "Body content is required" }),
  ctaText: z.string().min(1, { message: "CTA text is required" }),
  description: z.string().optional(),
  benefits: z.array(z.string()).optional(),
});

export type AutoRenewContent = z.infer<typeof autoRenewContentSchema>;

// Fallback content if CMS is not available or validation fails
export const fallbackAutoRenewContent: AutoRenewContent = {
  title: "Unlock savings with Auto-Renew",
  body: "Automatically refill your IV Nutrient Pack when it runs low—no need to remember to repurchase. Stay consistent with your wellness routine and get exclusive savings when you enroll.",
  ctaText: "Yes",
  benefits: [
    "Automatic refills",
    "Exclusive member pricing",
    "Convenient scheduling",
  ],
};

// Mock content for testing
export const mockAutoRenewContent: AutoRenewContent = {
  title: "Unlock savings with Auto-Renew",
  body: "Automatically refill your IV Nutrient Pack when it runs low—no need to remember to repurchase. Stay consistent with your wellness routine and get exclusive savings when you enroll.",
  ctaText: "Yes",
  benefits: [
    "Automatic refills",
    "Exclusive member pricing",
    "Convenient scheduling",
  ],
};
